import { render } from "./videoShow.vue?vue&type=template&id=509bfdaf&scoped=true"
import script from "./videoShow.vue?vue&type=script&lang=js"
export * from "./videoShow.vue?vue&type=script&lang=js"

import "./videoShow.vue?vue&type=style&index=0&id=509bfdaf&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509bfdaf"]])

export default __exports__